import http from './http';

export default {
  processWhiteGlovePayment(accountId, data) {
    return http().post(`/v1/support-service/${accountId}/process-payment`, data);
  },
}
